import { motion } from "framer-motion";
import { imageSrc, sceneImage } from "../../lib/api";

export function CozyHome({ painting }) {
  const landscape = painting.aspect_ratio > 1;
  return (
    <motion.div
      data-testid="love-cozy-home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2.2 }}
      className="absolute inset-0 z-20 overflow-hidden bg-[#140c0c]"
    >
      <motion.div
        className="absolute left-1/2 top-1/2"
        style={{ width: "max(106vw, 198vh)", aspectRatio: "1264 / 848", x: "-52%", y: "-38%", transformOrigin: "52% 38%" }}
        initial={{ scale: 1 }}
        animate={{ scale: 1.05 }}
        transition={{ duration: 9, ease: "easeInOut" }}
      >
        <img src={sceneImage("cozy_interior.jpg")} alt="" className="absolute inset-0 h-full w-full" />
        <div
          className="absolute"
          style={{
            left: "52%",
            top: "38%",
            transform: "translate(-50%, -50%)",
            height: landscape ? "auto" : `min(50%, ${(62 / painting.aspect_ratio).toFixed(1)}vw)`,
            width: landscape ? "min(34%, 70vw)" : "auto",
            aspectRatio: `${painting.aspect_ratio}`,
          }}
        >
          <div className="absolute -top-[9%] left-1/2 h-[2%] w-[46%] -translate-x-1/2 rounded-sm bg-[#3b2c1c] shadow-[0_2px_6px_rgba(0,0,0,0.6)]" />
          <div className="pointer-events-none absolute -top-[8%] left-1/2 h-[70%] w-[130%] -translate-x-1/2 bg-[radial-gradient(ellipse_at_50%_0%,rgba(255,214,150,0.55),transparent_65%)] mix-blend-screen" />
          <div className="relative h-full w-full shadow-[0_18px_40px_rgba(0,0,0,0.6)] outline outline-[5px] outline-[#2a1d14]">
            <img data-testid="love-home-painting" src={imageSrc(painting.image_url)} alt={painting.title} className="block h-full w-full" />
          </div>
        </div>
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_52%_40%,transparent_35%,rgba(10,5,8,0.55)_100%)]" />
      </motion.div>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2, delay: 2.4 }}
        className="pointer-events-none absolute inset-x-0 bottom-24 text-center font-display text-3xl italic text-[#FFF1F7] drop-shadow-[0_2px_14px_rgba(0,0,0,0.8)] sm:bottom-12"
      >
        and then, a home
      </motion.p>
    </motion.div>
  );
}
